import React from 'react';
import { Spin } from 'antd';

import { LoadingOutlined } from '@ant-design/icons';

// Default spinner colour is the brand token, not a literal `red` — a spinner is
// progress, and the two call sites that passed `'red'` explicitly meant "brand".
const Circular = ({
  size,
  color = 'var(--accent)',
  _sx,
  _loaderStyle,
  containerStyle,
  ..._props
}) => {
  return (
    <div style={containerStyle}>
      {/* <CircularProgress
                sx={sx}
                size={size} //Number
                color={color} //secondary | success | inherit
                style={loaderStyle}
                {...props}
            /> */}
      <Spin
        style={{
          color: color,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        indicator={<LoadingOutlined spin />}
        size={size}
      />
    </div>
  );
};

export default Circular;
